import React from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import {FormattedMessage, injectIntl} from 'react-intl';
import {withRouter} from 'react-router-dom';
import * as tracking from '../../../tracking';
import microsoftEntraID from '../../../images/integrations/microsoft-entra-id-logo.svg';
import CustomScrollDiv from '../../shared/components/scroll-bars/custom_scroll_div';
import AutosizeInput from 'react-input-autosize';
import Util from '../../shared/util/util';
import UpdateCompanyMutation from '../../../mutations/update_company_mutation.modern';
import ToggleSSOMutation from '../../../mutations/ToggleSSOMutation';
import {createToast} from '../../shared/components/toasts/another-toast/toaster';
import {ELEMENT_TYPE} from '../../../constants';
import {buildHeaderBar} from '../../shared/components/headers/header-bar/header_bar';
import {trackPage, unregisterPageInfo} from '../../../tracking/amplitude/TrackingV2';

class appAzureActiveDirectory extends React.Component {
	constructor(props) {
		super(props);

		const company = props.viewer.company;

		this.state = {
			AADTenant: company.AADTenant ? company.AADTenant : '',
			AADClientId: company.AADClientId ? company.AADClientId : '',
			AADClientSecret: company.AADClientSecret ? company.AADClientSecret : '',
			verifying: false,
		};

		this.superPropertyChecksum = trackPage('App Catalog - Microsoft Entra ID');
	}

	componentDidMount() {
		document.title = 'Microsoft Entra ID - Apps & Integrations - Forecast';
		// Segment
		tracking.trackPage('settings-app-catalog-azure');
	}

	componentWillUnmount() {
		unregisterPageInfo(this.superPropertyChecksum);
	}

	handleChange(property, e) {
		this.setState({[property]: e.target.value});
	}

	openHelpCenter() {
		window.open('https://support.forecast.app/hc/en-us/articles/5060804106001');
	}

	saveConfiguration() {
		this.setState({verifying: true});

		const onSuccess = () => {
			this.setState({verifying: false});
			createToast({duration: 10000, message: this.props.intl.formatMessage({id: 'common.settings_saved'})});
		};

		Util.CommitMutation(
			UpdateCompanyMutation,
			{
				id: this.props.viewer.company.id,
				AADTenant: this.state.AADTenant,
				AADClientId: this.state.AADClientId,
				AADClientSecret: this.state.AADClientSecret,
			},
			onSuccess
		);
	}

	activateSSO() {
		Util.CommitMutation(ToggleSSOMutation, {
			activateAAD: true,
		});
	}

	getHeader() {
		const leftContent = [],
			rightContent = [];

		leftContent.push({type: ELEMENT_TYPE.BACK_BUTTON, onClick: this.props.history.goBack});

		return buildHeaderBar(leftContent, rightContent);
	}

	render() {
		const {formatMessage} = this.props.intl;
		return (
			<div className="section-content settings-app settings-app-page">
				{this.props.children}
				{this.getHeader()}
				<CustomScrollDiv>
					<div className="section-body">
						<div className="inner">
							<fieldset className="general">
								<div className="header-wrapper">
									<img width={100} height={100} alt="azure" src={microsoftEntraID} />
									<div className="title-description-wrapper">
										<div className="description">
											<FormattedMessage id="settings.app_catalog.aad_description" />
										</div>
									</div>
								</div>

								{!this.props.viewer.company.AADEnabled ? (
									<button
										disabled={
											this.props.viewer.company.oktaEnabled || this.props.viewer.company.oneloginEnabled
										}
										className="submit-button"
										onClick={this.activateSSO.bind(this)}
									>
										<FormattedMessage id="common.activate" />
									</button>
								) : (
									''
								)}

								{this.props.viewer.company.AADEnabled ? (
									<div className="input-fields">
										<label htmlFor="ado_sso_url">
											<span>
												<strong>Microsoft Entra Tenant:</strong>
											</span>
											<AutosizeInput
												id="aad_sso_url"
												type="text"
												className="azure-account-name"
												placeholder={formatMessage({
													id: 'settings.app_catalog.harvest.account_name_placeholder',
												})}
												value={this.state.AADTenant}
												onChange={this.handleChange.bind(this, 'AADTenant')}
											/>
											.onmicrosoft.com
										</label>
										<label htmlFor="aad_client_id">
											<strong>Application client id</strong>
											<input
												id="ado_sso_client_id"
												type="text"
												placeholder="Client id"
												value={this.state.AADClientId}
												onChange={this.handleChange.bind(this, 'AADClientId')}
											/>
										</label>
										<label htmlFor="aad_client_secret">
											<strong>Application client secret</strong>
											<input
												id="aad_client_secret"
												type="password"
												placeholder="Client secret"
												value={this.state.AADClientSecret}
												onChange={this.handleChange.bind(this, 'AADClientSecret')}
											/>
										</label>
										{this.props.viewer.company.scimUsernamePassword ? (
											<label htmlFor="scim_bearer_token">
												<strong>SCIM bearer token</strong>
												<input
													id="scim_bearer_token"
													type="text"
													value={btoa(this.props.viewer.company.scimUsernamePassword)}
												/>
											</label>
										) : null}
										<button
											disabled={this.state.verifying}
											className="submit-button"
											onClick={this.saveConfiguration.bind(this)}
										>
											<FormattedMessage id="common.save" />
										</button>
										<button className="help-button" onClick={this.openHelpCenter.bind(this)}>
											<FormattedMessage id="settings.app_catalog.help_button" />
										</button>
									</div>
								) : (
									<button className="help-button" onClick={this.openHelpCenter.bind(this)}>
										<FormattedMessage id="settings.app_catalog.help_button" />
									</button>
								)}
							</fieldset>
						</div>
					</div>
				</CustomScrollDiv>
			</div>
		);
	}
}

const appAzureActiveDirectoryQuery = graphql`
	query appAzureActiveDirectory_Query {
		viewer {
			actualPersonId
			component(name: "app_azure_active_directory")
			...appAzureActiveDirectory_viewer
		}
	}
`;

export {appAzureActiveDirectoryQuery};

export default createFragmentContainer(injectIntl(withRouter(appAzureActiveDirectory)), {
	viewer: graphql`
		fragment appAzureActiveDirectory_viewer on Viewer {
			id
			company {
				id
				AADEnabled
				oneloginEnabled
				oktaEnabled
				scimUsernamePassword
				AADTenant
				AADClientId
				AADClientSecret
			}
		}
	`,
});
